export default "__VITE_ASSET__Boz4G0Xh__"